module.exports = __webpack_public_path__ + "static/media/MIAB9768-180730-101_Small.a668b0fc.jpg";